import styled, { createGlobalStyle } from 'styled-components';
import { Select, DatePicker, Tag } from 'antd';
import { IToken } from 'store/ducks/globalTypes';

export const EntitySelect = styled(Select)`
  width: 120px;
  margin-right: 8px;
  z-index: 1050;

  .ant-select-selector {
    overflow: visible;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 120px;
  margin-right: 8px;
`;

export const RiskInventoryFilterBar = styled.div`
  max-width: 100%;
  margin-left: 20px;
`;

export const ProcessTag = styled(Tag)`
  display: inline-block;
  margin-bottom: 4px;
  white-space: normal;
  word-wrap: break-word;
`;

export const riskInventoryHeaderStyle = {
  paddingTop: '0px',
  paddingBottom: '0px',
  borderBottom: 'none',
  verticalAlign: 'middle',
  height: '56px',
  position: 'relative'
};

export const riskInventoryDateHeaderStyle = {
  paddingTop: '0px'
};

export const riskInventoryStartDateCellStyle = {
  borderRight: '1px solid #d9d9d9'
};

export const RiskInventoryTableWrapper = styled.div`
  .ant-table-thead > tr:nth-child(2) > th {
    padding: 0;
    height: 0;
    line-height: 0;
    border: 0;
  }

  .ant-table-thead > tr:nth-child(2) > th::before {
    display: none;
    content: none;
  }
`;

export const GlobalDatePickerStyle = createGlobalStyle<IToken>`
  .white-bg-datepicker .ant-picker-panel-container {
    background: #ffffff !important;
  }

  .white-bg-datepicker .ant-picker-panel {
    background: #ffffff !important;
  }

  .white-bg-datepicker .ant-picker-date-panel,
  .white-bg-datepicker .ant-picker-body {
    background: #ffffff !important;
  }
`;
